module.exports = __webpack_public_path__ + "static/media/edresult2.d517b65e.png";